export default {
  zh: {
    columns: {
      field: '字段',
      condition: '条件',
      value: '字段值',
      tip: '请使用逗号分隔多个筛选条件，但不适用于日期或时间选择器',
      emptyMsg: '请先从左侧选择任一字段',
    },
    buttons: {
      newFilter: '新筛选条件',
    },
    inputs: {
      condition: '筛选条件间的关系',
    },
  },
  en: {     
    columns: {
      field: 'Field',
      condition: 'Condition',
      value: 'Value',
      tip: 'Use comma to separate filter rules except for Date or Datetime field.',
      emptyMsg: 'Please select a field firstly on the left-hand side.',
    },
    buttons: {
      newFilter: 'New Filter',
    },
    inputs: {
      condition: 'Condition Logic',
    },
  },
};



// WEBPACK FOOTER //
// ./src/components/page/FilterCriteria/i18n.js